// extracted by mini-css-extract-plugin
export default {"card":"B4-z","carouselContainer":"C4-z","carouselContent":"D4-z"};